import styled from 'styled-components';
import { DebounceInput } from 'react-debounce-input';
import { mixins, styles } from '4all-ui/styles';
import { container } from '../../../style/mixins';
import SearchIcon from '../../../images/icon-search.svg';

export const filtersHeader = styled.p`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_5, styles.fontWeights.NORMAL)}
  margin-bottom: 15px;
`;

export const Container = styled.div`
  ${container}
  padding: 20px;
`;

export const SearchInput = styled(DebounceInput)`
  width: 100%;
  height: 40px;
  padding: 0px 45px 0px 10px;
  border: 1px solid ${styles.colors.GRAY_LIGHT_2};
  border-radius: ${styles.borders.RADIUS_1};
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  ${mixins.flexPosition({ align: 'center' })}
  
  &::placeholder {
    ${mixins.fontStyle(
      styles.colors.GRAY_MEDIUM,
      styles.fontSizes.SIZE_7,
      styles.fontWeights.SEMIBOLD
    )}
  }
`;

export const InputContainer = styled.div`
  position: relative;
  margin-top: 15px;
  margin-bottom: 10px;
  ${mixins.flexPosition({ align: 'center' })}

  &::after {
    position: absolute;
    right: 15px;
    content: '';
    background-image: url(${SearchIcon});
    background-repeat: no-repeat;
    width: 17px;
    height: 17px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/OrderList/SearchBox/style.js